import React from 'react';
import { TileLayer } from 'react-leaflet';
import { getTileLayerConfig } from '../basemap/tileConfig';

export default function TraffixTileLayer({ theme }) {
  const config = getTileLayerConfig(theme);
  return (
    <TileLayer
      key={theme}
      url={config.url}
      maxZoom={config.maxZoom}
      maxNativeZoom={config.maxNativeZoom}
      opacity={config.opacity}
      attribution={config.attribution}
    />
  );
}
